// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "assets_3.26.0/js/[name].bundle" + "-" + "b0cbb2d8b22e3a751ecf" + "-bundle.js";
};